import React from 'react';
import PropTypes from 'prop-types';
import Table from 'components/table/Table';
import { useDispatch } from 'react-redux';
import { formatDate } from 'controls/utils';
import { getDownloadLink } from 'actions/download';
import { Language } from 'language/Language';
import { strings } from './strings';
import './_Download.scss';

const SO = ['WINDOWS', 'MACOS'];

const DownloadTable = ({ dataToMap }) => {
  const dispatch = useDispatch();
  const language = Language();
  const headers = [strings[language].product, strings[language].remaining, strings[language].expires, strings[language].download];

  const getLink = async (id, platform) => {
    const link = await dispatch(getDownloadLink(id, platform));
    window.location.href = link;
  };

  return (
    <Table>
      <>
        <Table.Header headers={headers} />
        <Table.Content>
          <>
            {dataToMap
              ? SO.map((so, j) => (
                <div className='table-row' key={`${so}-${dataToMap.entitlementID}`}>
                  <div className='table-content__item download-item'>
                    <p>{dataToMap.name && dataToMap.name}</p>
                  </div>
                  <div className='table-content__item download-item'>
                    <p>∞</p>
                  </div>
                  <div className='table-content__item download-item'>
                    <p>{dataToMap.expiration && formatDate(dataToMap.expiration)}</p>
                  </div>
                  <div className='table-content__item download-item'>
                    { j === 0
                      ? (
                        <button
                          className='table-content__link download-link'
                          onClick={() => getLink(dataToMap.entitlementID, 'Windows')}
                          type='button'
                          style={{ height: '100%', width: '100%' }}
                        >
                          <h3>{so}</h3>
                        </button>
                      )
                      : (
                        <button
                          className='table-content__link download-link'
                          onClick={() => getLink(dataToMap.entitlementID, 'macOS')}
                          type='button'
                          style={{ height: '100%', width: '100%' }}
                        >
                          <h3>{so}</h3>
                        </button>
                      )}
                  </div>
                </div>
              ))
              : (
                <p style={{ marginTop: '1rem' }}>No download has been made yet.</p>
              )}
          </>
        </Table.Content>
      </>
    </Table>
  );
};

DownloadTable.propTypes = {
  dataToMap: PropTypes.object,
};

export default DownloadTable;
